import React, { useEffect } from "react";
import thankyou from "../../../assets/img/Thank You.svg";

const ThankYou = () => {


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="simple-renovate padding_top simple-renovate-2">
      <div className="container-2">
        <h1 className="logo">
          Simple<span className="logo-highlight">Renovate</span>
        </h1>

        <div className="coming-soon">
          <div>
            <span>Coming Soon</span>
          </div>
          <div className="underline"></div>
        </div>

        <p className="description">
          We're building the ultimate platform to connect homeowners with
          trusted renovation professionals.
        </p>

        <p className="cta-text">Be the first to know when we launch!</p>

        <div className="signup-form-2">
          <img src={thankyou} alt="Thank You" className="mb-3 mb-md-4" />
          <h2>Thank You!</h2>

          <p className="description p-0">
            We've received your information and will notify you as soon as we
            launch. Get ready for a better renovation experience!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
